import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var ChartLineIcon = ZepIcon_default((props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M19 17H6V6a1 1 0 1 0-2 0v12a1 1 0 0 0 1 1h14a1 1 0 1 0 0-2Z",
      fill: props.fill || "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.31 7a1 1 0 0 0 1 1h1.64l-2.443 2.443-.736-.736a.998.998 0 0 0-.764-.291.998.998 0 0 0-.764.291l-3.536 3.536a1 1 0 0 0 1.414 1.414l2.886-2.886.764.764a1 1 0 0 0 1.414 0h.001a1 1 0 0 0 .228-.171l2.896-2.897V11a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1Z",
      fill: props.fill || "currentColor"
    }
  )
] }));

export { ChartLineIcon };
